import axiosIdentity from "@/store/axiosIdentity";
const resource = "/Users";

export default {
  getById: (userId: any = {}): any => {
    return axiosIdentity.get(`${resource}/${userId}`, null);
  },
  getUserAuthorizedEntities: (userId: any = {}): any => {
    return axiosIdentity.get(`/GetUserAuthorizedEntities/${userId}`, null);
  },
};
